import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Content from 'Settings/Content';
import { findClearanceLevels } from '../SecFunctions';
import { XGrid } from '@material-ui/x-grid';
import { handleError } from 'reducers/ErrorReducer';
import Fab from '@material-ui/core/Fab';
import QuickFilter from 'components/QuickFilter';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from 'components/Tooltip';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import InfoIcon from '@mui/icons-material/Info';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(2),
    '& > h5': {
      marginBottom: 20,
    },
  },
  edit: {
    padding: theme.spacing(2, 0),
    paddingBottom: 12,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  form: {
    margin: '0 -4px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'start',
    flexGrow: 1,
  },
  buttons: {
    '& button': {
      marginLeft: theme.spacing(1),
    },
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  textField: {
    margin: '0 4px 8px',
  },
  list: {
    width: '100%',
    height: 500,
  },
  actions: {
    width: '100%',
    padding: theme.spacing(1, 0, 2),
    textAlign: 'right',
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 500,
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));


const columns = [
  { field: 'Level', headerName: 'Level', width: 250 },
  { field: 'Description', headerName: 'Description', width: 250 },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 250 },
];


function Clearance(props) {
  const classes = useStyles();
  const [selection, setSelection] = useState(null);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);


  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    try{
    const result = await findClearanceLevels();
    setRows(processData(result));
    } catch(err) {
      props.handleError(err, 'Error, cannot get data.');
    }
  }


  const processData = (data) => {
    return data.map(row => {
      return {
        ...row,
        id: row.ptsClearanceLevelID,
      };
    });
  };


  // const handleDetails = () => {
  //   console.log('selection: ', selection)
  // }


  const renderList = () => {
    return (
      <div className={classes.gridWrap}>
        <XGrid
          columns={columns}
          rows={filteredRows}
          rowHeight={38}
          disableMultipleSelection={true}
          showToolbar
          disableColumnFilter
          onSelectionModelChange={(newSelection) => {
            setSelection(newSelection.selectionModel[0]);
          }}
        />
      </div>
    )
  }

  
  return (
    <Content>
      <div className={classes.wrap}>
        <h4> Clearance Levels </h4>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className={classes.filterWrap}>
            <div className={classes.filterWrap}>
              <QuickFilter
                rows={rows}
                columns={columns}
                setFilteredRows={setFilteredRows}
              />
            </div>
            {/* <div className={classes.actions}>
              <Fab onClick={addSecUser} size="small" color="secondary">
                <AddIcon />
              </Fab>
              {selection !== null && (
                <Tooltip title="Details">
                  <Fab className="ml-2" size="small" color="secondary" onClick={handleDetails}>
                    <InfoIcon />
                  </Fab>
                </Tooltip>
              )}
            </div> */}
          </div>
        </MuiPickersUtilsProvider>
        {renderList()}
      </div>
    </Content>
  );
}


export default connect(null, {  handleError })(Clearance);
